import React, {CSSProperties, ReactNode} from 'react'

export default function Heading(props: {
  align?:
    | 'start'
    | 'end'
    | 'left'
    | 'right'
    | 'center'
    | 'justify'
    | 'match-parent'
  children: ReactNode | string
  color?: string
  fontSize?: number
  fontWeight?: number | string
  lineHeight?: number
  margin?: string
  mb?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  ml?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  mr?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  mt?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  style?: CSSProperties
}) {
  if (!props.children) {
    return null
  }

  return (
    <h3
      style={{
        fontWeight: 'bold',
        fontSize: '36px',
        lineHeight: '43px',
        color: props.color || '#000000',
        marginBlockStart: 0,
        marginBlockEnd: 0,
        margin: props.margin,
        marginBottom: props.mb ? props.mb * 4 : undefined,
        marginTop: props.mt ? props.mt * 4 : undefined,
        marginLeft: props.ml ? props.ml * 4 : undefined,
        marginRight: props.mr ? props.mr * 4 : undefined,
        textAlign: props.align ?? undefined,
        ...props.style,
      }}
    >
      {props.children}
    </h3>
  )
}
